import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function AddChatbot() {
    return (
        <OnboardingBody title='Add an AI chatbot to your site' statusText='New: AI Chatbot'>
            <p>
                First, install the Nutshell {/* @ts-expect-error */}
                <Link to='/setup/tracking-snippet' as={RouterLink} newTab={true}>
                    tracking snippet
                </Link>{' '}
                (or use our{' '}
                <Link href='https://wordpress.org/plugins/nutshell-analytics/' newTab={true}>
                    WordPress plugin
                </Link>
                ) to enable chat on your site. Then, use the display toggle to decide when the chat
                widget should appear.
            </p>
        </OnboardingBody>
    );
}
